import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { login, checkCodeTotp } from "../../actions/loginActions";
import { checkout } from "../../actions/registerActions";


function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));
export default function Mfa(props) {
  const { register, handleSubmit, watch, errors } = useForm();
  const dispatch = useDispatch();
  const classes = useStyles();
  const plan = useSelector((state) => state.register.plan);
  const [selectedPlan, setSelectedPlan] = useState(plan ? plan : "Basic");
  const [username, setUsername] = useState(props.username)
  const [password, setPassword] = useState(props.password)
  const [error, setError] = useState(false)


  const onSubmit = async data => {
    await checkCodeTotp({ "code": data.company, "username": username }).then(data => {
      if (data) {
        dispatch(login({ username: username, password: password })).then(auth => {
          if (auth.sessionId) {
            checkout(auth.plan, auth.sessionId);
          }
        });
      }
      else {
        setError(true)
      }
    });
  }


  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          Use the code from your authenticator app
        </Typography>
        <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl variant="outlined" required fullWidth>
              </FormControl>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <TextField
              variant="outlined"
              required
              fullWidth
              id="company"
              label="MFA code"
              name="company"
              autoComplete="code"
              inputProps={{ ref: register }}
            />
          </Grid>
          <span>{error ? "Incorrect code, please try again" : ""}&nbsp;</span>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Login
          </Button>
        </form>
      </div>
    </Container>
  );
}